import {gql} from "@apollo/client";

export const GetAdventures4User = gql`
    query getAdventure4User($userId: Int!) {
        getAdventure4User(userId: $userId) {
            adventureId
            adventureDescription
            adventureName
            user_to_adventure {
                userToAdventureId
                User {
                    userId
                    userName
                }
            }
        }
    }
`

export const GetAdventures = gql`
    query getAdventures {
        getAdventures {
            adventureId
            adventureName
            adventureDescription
            user_to_adventure {
                userToAdventureId
                User {
                    userId
                    userName
                }
            }
        }
    }
`

export const GetAdventureById = gql`
    query getAdventureById($adventureId: Int!) {
        getAdventureById(adventureId: $adventureId) {
            adventureId
            adventureDescription
            adventureName
            Character {
                characterId
                characterName
                User {
                    userId
                }
            }
            user_to_adventure {
                userToAdventureId
                User {
                    userName
                    userId
                    userRole
                    Character {
                        characterName
                        characterId
                        CharacterSheet {
                            currentHitpoints
                            lifepoints
                        }
                    }
                }
            }
        }
    }
`

export const GetNewUser4Adventure = gql`
    query getNewUser4Adventure($adventureId: Int!) {
        getNewUser4Adventure(adventureId: $adventureId) {
            userId
            userName
        }
    }
`

export const GetKampagne4User = gql`
    query GetKampagne4User($userId: Int!) {
        getKampagne4User(userId: $userId) {
            adventureName
            adventureId
            adventureDescription
        }
    }
`